import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTablePembayaranHutang } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";

const TampilPembayaranHutang = () => {
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();

  const [isFetchError, setIsFetchError] = useState(false);
  const [tanggalPembayaranHutang, setTanggalPembayaranHutang] = useState("");
  const [noPembayaranHutang, setNoPembayaranHutang] = useState("");
  const [totalPembayaranHutang, setTotalPembayaranHutang] = useState("");
  const [jenisPembayaranHutang, setJenisPembayaranHutang] = useState("");

  const [beliId, setBeliId] = useState("");
  const [noNotaBeli, setNoNotaBeli] = useState("");
  const [namaSupplier, setNamaSupplier] = useState("");
  const [totalBeli, setTotalBeli] = useState("");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [pembayaranHutangs, setPembayaranHutangs] = useState([]);
  const [pembayaranHutangsPagination, setPembayaranHutangsPagination] =
    useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");
  const PER_PAGE = 20;

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    id && getPembayaranHutangById();
  }, [id]);

  useEffect(() => {
    getPembayaranHutangsPagination();
  }, [page, searchTerm]);

  const getPembayaranHutangsPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/pembayaranHutangsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setQuery(searchTerm);
      setPembayaranHutangsPagination(response.data.pembayaranHutangs);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (err) {
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getPembayaranHutangs = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/pembayaranHutangs`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setPembayaranHutangs(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getPembayaranHutangById = async () => {
    if (id) {
      setLoading(true);
      const response = await axios.post(`${tempUrl}/pembayaranHutangs/${id}`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setTanggalPembayaranHutang(
        response.data.tanggalPembayaranHutangFormatted
      );
      setNoPembayaranHutang(response.data.noPembayaranHutang);
      setTotalPembayaranHutang(
        response.data.totalPembayaranHutang.toLocaleString("en-US")
      );
      setJenisPembayaranHutang(response.data.jenisPembayaranHutang);

      setBeliId(response.data.beli.id);
      setNoNotaBeli(response.data.beli.noNotaBeli);
      setNamaSupplier(response.data.beli.supplier.namaSupplier);
      setTotalBeli(response.data.beli.totalBeli.toLocaleString("en-US"));
      setLoading(false);
    }
  };

  const deletePembayaranHutang = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deletePembayaranHutang/${id}`, {
        beliId,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setSearchTerm("");
      setTanggalPembayaranHutang("");
      setNoPembayaranHutang("");
      setTotalPembayaranHutang("");
      setJenisPembayaranHutang("");

      setBeliId("");
      setNoNotaBeli("");
      setNamaSupplier("");
      setTotalBeli("");
      getPembayaranHutangsPagination();
      navigate("/pembayaranHutang");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(
          `${totalPembayaranHutang} tidak bisa dihapus karena sudah ada data!`
        );
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date =
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getFullYear();
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Pembayaran Hutang`, 85, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    doc.save("daftarPembayaranHutang.pdf");
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "PembayaranHutang",
    sheet: "DaftarPembayaranHutang",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      <h3>Pembelian</h3>
      <h5 style={{ fontWeight: 400 }}>Pembayaran Hutang</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getPembayaranHutangs();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getPembayaranHutangs();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="styled-table" id="table">
            <thead>
              <tr>
                <th>No. Beli</th>
                <th>Tgl. Beli</th>
                <th>No. Bayar</th>
                <th>Tgl. Bayar</th>
                <th>Supplier</th>
                <th>Jenis</th>
                <th>Total Beli</th>
                <th>Total Bayar</th>
              </tr>
            </thead>
            <tbody>
              {pembayaranHutangs.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.beli.noNotaBeli}</td>
                  <td>{user.tanggalBeliFormatted}</td>
                  <td>{user.noPembayaranHutang}</td>
                  <td>{user.tanggalPembayaranHutangFormatted}</td>
                  <td>{user.beli.supplier.namaSupplier}</td>
                  <td>{user.jenisPembayaranHutang}</td>
                  <td>{user.totalPembayaranHutang.toLocaleString("en-US")}</td>
                  <td>{user.beli.totalBeli.toLocaleString("en-US")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table class="styled-table" id="table" ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>No. Beli</th>
                <th>Tgl. Beli</th>
                <th>No. Bayar</th>
                <th>Tgl. Bayar</th>
                <th>Supplier</th>
                <th>Jenis</th>
                <th>Total Beli</th>
                <th>Total Bayar</th>
              </tr>
              {pembayaranHutangs.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.beli.noNotaBeli}</td>
                  <td>{user.tanggalBeliFormatted}</td>
                  <td>{user.noPembayaranHutang}</td>
                  <td>{user.tanggalPembayaranHutangFormatted}</td>
                  <td>{user.beli.supplier.namaSupplier}</td>
                  <td>{user.jenisPembayaranHutang}</td>
                  <td>{user.totalPembayaranHutang.toLocaleString("en-US")}</td>
                  <td>{user.beli.totalBeli.toLocaleString("en-US")}</td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/pembayaranHutang/tambahPembayaranHutang`}
          editLink={null}
          deleteUser={deletePembayaranHutang}
          nameUser={totalPembayaranHutang}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Tgl. Bayar :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={tanggalPembayaranHutang}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    No. Bayar :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={noPembayaranHutang}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    No. Beli :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={noNotaBeli} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Nama Supplier :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={namaSupplier} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Jenis Transfer :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={jenisPembayaranHutang}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Total Hutang :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={totalBeli} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Total Bayar :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={totalPembayaranHutang}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTablePembayaranHutang currentPosts={pembayaranHutangsPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilPembayaranHutang;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
